import React from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import Styled, { css } from "styled-components";

import ScriptureHtmlView from "../ScriptureView/ScriptureHtmlView";
import ScriptureView from "../ScriptureView/ScriptureView";
import { chapterPath } from "../../utils/paths";

const PassageView = Styled.div`
${props =>
  props.ellipsize &&
  css`
    overflow: hidden;
    // text-overflow: ellipsis;
    max-height: 10em;
  `}
`;

const Passage = props => {
  let scriptureView;

  if (typeof props.passage.content === "object") {
    scriptureView = (
      <ScriptureView
        bibleId={props.bibleId}
        content={props.passage.content}
        scriptDirection={props.scriptDirection}
        showVerseActions={false}
      />
    );
  } else {
    scriptureView = <ScriptureHtmlView content={props.passage.content} />;
  }

  const passageView = (
    <PassageView class="testing" ellipsize={props.ellipsize}>
      <h3>{props.passage.reference}</h3>
      {scriptureView}
    </PassageView>
  );

  if (props.link) {
    const {
      bibleId,
      passage: { chapterIds, orgId },
      location
    } = props;
    return (
      <Link
        to={chapterPath({
          bibleId,
          chapterId: chapterIds[0],
          passageId: orgId,
          location
        })}
      >
        {passageView}
      </Link>
    );
  }

  return passageView;
};

Passage.propTypes = {
  bibleId: PropTypes.string.isRequired,
  passage: PropTypes.shape({
    id: PropTypes.string.isRequired,
    reference: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    chapterIds: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired,
  scriptDirection: PropTypes.string,
  link: PropTypes.bool,
  ellipsize: PropTypes.bool
};

Passage.defaultProps = {
  link: false,
  ellipsize: false,
  scriptDirection: "ltr"
};

export default withRouter(Passage);
